import { GuiBase } from "../GuiBase";

export class GuiLoginChange extends GuiBase {

    constructor() {
        super("LoginChange");
    }

}
